import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { PdfExportService } from '../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../services/user.service';
import {chartConfig, CommonConstant} from '../../../app.constants';

@Component({
  selector: 'top-mention',
  templateUrl: './top-mention.component.html',
  styleUrls: ['./top-mention.component.scss']
})
export class TopMentionComponent implements OnInit, AfterViewInit {
  static COMPONENT_NAME = 'TopMentionComponent';

  @Input() data: Array<object>;
  @Input() isFallbackView = false;
  left: Array<object> = [];
  right: Array<object> = [];

  constructor(protected pdfService: PdfExportService,
              protected userService: UserService) { }

  ngOnInit() {
    if (!this.data || this.data.length === 0) {
      return;
    }

    // devide left and right to have the same row if total row < 9
    if (this.data.length < 9) {
      const maRowPerColumn = Math.ceil(this.data.length / 2);
      this.left = this.data.slice(0, maRowPerColumn);
      this.right = this.data.slice(maRowPerColumn, 10);
    } else {
      this.left = this.data.slice(0, 5);
      this.right = this.data.slice(5, 10);
    }
  }

  get bgColor() {
    return this.isFallbackView ? chartConfig.fallbackViewColor : this.userService.chartColors[CommonConstant.BLUE_COLOR_INDEX];
  }

  get noDataAvailable() {
    return !this.data || this.data.length === 0;
  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(TopMentionComponent.COMPONENT_NAME);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/top-mention/top-mention.component.ts